// extracted by mini-css-extract-plugin
export default {"container":"CardOfProject_container__SdWy5","buttonInProjectCard":"CardOfProject_buttonInProjectCard__cQIpH","iconEyes":"CardOfProject_iconEyes__pqKno"};